import BsInvoiceSearch from './index.vue'
export default BsInvoiceSearch